import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  walletSettlementListRequest
} from '../../../redux/actions/wallet/settlementActions';
import { DEFAULT_END_AT, DEFAULT_START_AT_30_DAYS } from '../../LogManagement/constants';
import { getUserPageAuth } from '../../../utils/page-auth';
import Notification from '../../../components/Notification/Notification';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TextField from '@mui/material/TextField';
import timeFormAPI from '../../../api/ui/timeFormAPI';

function settlemented() {
  // -- component const --//
  const tHeadTotal = [
    '토큰',
    '소각할 토큰',
    '마켓 수수료',
    'NFT 거래 로열티',
    '월렛 계좌 전송 수수료',
    '월렛 NFT 전송 수수료',
    '상점 판매 액',
  ];

  const tHeadSelectable = [
    '정산 번호',
    '날짜',
    '토큰',
    '소각할 토큰',
    '마켓 수수료',
    'NFT 거래 로열티',
    '월렛 계좌 전송 수수료',
    '월렛 NFT 전송 수수료',
    '상점 판매 액',
  ];

  const tokens = ['XPER', 'PER', 'ARB'];

  const settlementDataKeys = [
    'settlementId',
    'date',
    ...tokens,
    'BurningFee',
    'MarketFee',
    'MarketRoyaltyFee',
    'TransactionFee',
    'NftTransactionFee',
    'ProductFee',
  ];

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();

  const user = useSelector((state) => state.authReducer.user);

  // -- state --//
  const [readOnly, setReadOnly] = useState(true);

  const [startAt, setStartAt] = useState(DEFAULT_START_AT_30_DAYS);
  const [endAt, setEndAt] = useState(DEFAULT_END_AT);

  const [tBodyTotal, setTbodyTotal] = useState();
  const [totalList, setTotalList] = useState();
  const [totalCount, setTotalCount] = useState(0);
  const [tBodySelectable, setTbodySelectable] = useState();

  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  // 로딩
  const [isLoadingTotal, setIsLoadingTotal] = useState(false);
  const [isLoadingSelectable, setIsLoadingSelectable] = useState(false);

  // -- func & handler --//
  const fetchList = () => {

    dispatch(walletSettlementListRequest({
      transactionStatus: 2, // 정산 완료 데이터 요청
      settlementType: 0,
      from: startAt,
      to: endAt,
      settlementIds: [],
      callback: (data) => {
        console.log(data);
        setTbodyTotal(data?.totalSettlements);
        setTbodySelectable(data?.list);
        setTotalCount(data?.list.length);
        setTotalList(data?.settlementIds);
      },
      error: (e) => {
        console.log(e);
        setNotificationMessage(e.toString());
        setShowNotification(true);
      },
    }))

  }

  // -- react hooks --//
  useEffect(() => {
    dispatch(walletSettlementListRequest({
      transactionStatus: 2, // 정산 완료 데이터 요청
      settlementType: 0,
      from: startAt,
      to: endAt,
      settlementIds: [],
      callback: (data) => {
        console.log(data);
        setTbodyTotal(data?.totalSettlements);
        setTbodySelectable(data?.list);
        setTotalCount(data?.list.length);
        setTotalList(data?.settlementIds);
      },
      error: (e) => {
        console.log(e);
        setNotificationMessage(e.toString());
        setShowNotification(true);
      },
    }))
  }, []);

  useEffect(() => {
    getUserPageAuth(user).then((res) => setReadOnly(res));
  }, [user]);

  useEffect(() => {
    if (tBodyTotal !== null && tBodyTotal !== undefined) {
      setTbodyTotal(tBodyTotal);
    } else {
      setTbodyTotal([]);
    }

    setIsLoadingTotal(false);
  }, [tBodyTotal]);

  useEffect(() => {
    if (tBodySelectable !== null && tBodySelectable !== undefined) {
      setTbodySelectable(tBodySelectable);
    } else {
      setTbodySelectable([]);
    }

    setIsLoadingSelectable(false);
  }, [tBodySelectable]);

  // -- render --//
  return (
    <div className="page">

      <div className="contentsArea paddingAll">
        <div className="rowDiv">
          <div className="titleDiv">조회 날짜 범위</div>
          <div className="spaceDiv10"/>
          <div className="descDiv date">
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DateTimePicker
                value={startAt}
                onChange={(date) => {
                  setStartAt(date.format('YYYY-MM-DDTHH:mm:ss'));
                }}
                renderInput={(params) => (
                  <TextField {...params} variant="standard"/>
                )}
              />
            </LocalizationProvider>

            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DateTimePicker
                value={endAt}
                onChange={(date) => {
                  setEndAt(date.format('YYYY-MM-DDTHH:mm:ss'));
                }}
                renderInput={(params) => (
                  <TextField {...params} variant="standard"/>
                )}
              />
            </LocalizationProvider>

            <button
              className="defaultBtn"
              onClick={() => {
                fetchList();
              }}
            >
              조회
            </button>
          </div>
        </div>
      </div>

      <div className="spaceDiv10"/>

      <div className="subTitleText addBtn">
        <p>
          {`기간 합계 ${totalList && totalList[totalList?.length - 1]} ~ ${totalList && totalList[0]}`}
        </p>
      </div>

      <div className="spaceDiv10"/>

      <table style={{ tableLayout: 'fixed' }}>
        <thead>
        <tr>
          {
            tHeadTotal.map((header, index) => (
              <th key={index} className="">
                {header}
              </th>
            ))
          }
        </tr>
        </thead>
        <tbody>
        {isLoadingTotal ? (
          <tr>
            <td
              colSpan={tHeadTotal.length}
              style={{
                textAlign: 'center',
                backgroundColor: '#FAFBFC'
              }}
            >
              Loading...
            </td>
          </tr>
        ) : totalCount > 0 ? (tokens.map((token, index) => (
          <tr key={index}>
            <td className="">
              {token}
            </td>
            {
              settlementDataKeys.slice(tokens.length)
                .filter((key) => Object.keys(tBodyTotal ?? [])
                  .includes(key))
                .map((key) => (
                  <td key={`${token}-${key}`} className="">
                    {
                      tBodyTotal[key]
                      &&
                      tBodyTotal[key][token.toLowerCase()]
                    }
                  </td>
                ))
            }
          </tr>
        ))) : (
          <tr>
            <td
              colSpan={tHeadTotal.length}
              style={{
                textAlign: 'center',
                backgroundColor: '#FAFBFC'
              }}
            >
              등록된 정산 정보가 없습니다.
            </td>
          </tr>
        )
        }
        </tbody>
      </table>

      <div className="spaceDiv10"/>

      <div className="subTitleText addBtn">
        <p>
          {`정산 완료 내역 (${totalCount})`}
        </p>
      </div>

      <div className="spaceDiv10"/>

      <table style={{ tableLayout: 'inherit' }}>
        <thead>
        <tr>
          {tHeadSelectable.map((i, index) => (
            <th key={index} className="" style={{ width: index === 0 ? 'inherit' : 'auto' }}>
              {i}
            </th>
          ))}
        </tr>
        </thead>
        <tbody>
        {isLoadingSelectable ? (
          <tr>
            <td
              colSpan={tHeadSelectable.length}
              style={{
                textAlign: 'center',
                backgroundColor: '#FAFBFC'
              }}
            >
              Loading...
            </td>
          </tr>
        ) : totalCount > 0 ? (tBodySelectable?.map((settlement) => {
          return (
            <React.Fragment key={settlement.settlementId}>
              {tokens.map((token, rowIndex) => (
                <tr key={`${settlement.settlementId}-${token}`}>
                  {rowIndex === 0 && (
                    <>
                      <td className="" rowSpan={tokens.length}>
                        {settlement.settlementId}
                      </td>
                      <td className="" rowSpan={tokens.length}>
                        {timeFormAPI.changeDataDate(settlement.date)}
                      </td>
                    </>
                  )}
                  <td className="">{token}</td>
                  {settlementDataKeys.slice(tokens.length + 2)
                    .map((key) => (
                      <td key={`${settlement.settlementId}-${key}-${token}`} className="">
                        {
                          settlement.settlements[key]
                          &&
                          settlement.settlements[key][token.toLowerCase()]
                        }
                      </td>
                    ))}
                </tr>
              ))}
            </React.Fragment>
          );
        })) : (
          <tr>
            <td
              colSpan={tHeadSelectable.length}
              style={{
                textAlign: 'center',
                backgroundColor: '#FAFBFC'
              }}
            >
              등록된 정산 정보가 없습니다.
            </td>
          </tr>
        )
        }
        </tbody>
      </table>

      {
        showNotification ? (
          <Notification
            close={() => setShowNotification(false)}
            message={notificationMessage}
          />
        ) : null
      }

    </div>
  )
}

export default settlemented;
